import _jsx from "@babel/runtime/helpers/jsx";
import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import Typography from '@mui/material/Typography';
import { FormattedMessage, injectIntl } from 'react-intl';
import { compose } from 'redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import PropTypes from 'prop-types';
import map from 'lodash/map';
import CustomModal from '../Modals/Modal';
import Link from '../Link/Link';
import s from './BundleCertDetails.scss';
import messages from './messages';
import { ModalCloseBtn } from '../statelessComponents/Buttons/ButtonsInModals';
import Attachment from '../ReduxFormAttachments/Attachment/Attachment';
import intlPropTypes from '../../constants/intlPropTypes';
var BundleCertDetails = function BundleCertDetails(_ref) {
  var isOpen = _ref.isOpen,
    name = _ref.name,
    onClose = _ref.onClose,
    certificates = _ref.certificates,
    _ref$files = _ref.files,
    files = _ref$files === void 0 ? [] : _ref$files,
    ariaDescribedBy = _ref.ariaDescribedBy,
    _ref$includedCertsTit = _ref.includedCertsTitle,
    includedCertsTitle = _ref$includedCertsTit === void 0 ? '' : _ref$includedCertsTit,
    _ref$attachedFilesTit = _ref.attachedFilesTitle,
    attachedFilesTitle = _ref$attachedFilesTit === void 0 ? '' : _ref$attachedFilesTit;
  return /*#__PURE__*/_jsx(CustomModal, {
    "aria-describedby": ariaDescribedBy,
    isOpen: isOpen,
    width: "60%",
    onClose: onClose
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: s.certList
  }, void 0, !!(certificates !== null && certificates !== void 0 && certificates.length) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/_jsx(Typography, {
    variant: "h5",
    component: "h1"
  }, void 0, includedCertsTitle || /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.includedCertsTitle, {
    values: {
      certName: name
    }
  }))), map(certificates, function (item) {
    return /*#__PURE__*/_jsx(Link, {
      "data-test-id": "0KTKHpdqXo0BzbLkPzBAJ",
      to: "/cert/".concat(item.code),
      target: "_blank",
      onClick: onClose
    }, item._id, /*#__PURE__*/_jsx(Typography, {
      variant: "body1"
    }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, _extends({
      values: {
        name: item.name,
        supervisorOrganization: item.supervisorOrganization || '',
        supervisor: item.supervisor || '',
        code: item.code
      }
    }, messages.certItem))));
  })), !!(files !== null && files !== void 0 && files.length) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/_jsx(Typography, {
    variant: "h5",
    component: "h1"
  }, void 0, attachedFilesTitle || /*#__PURE__*/React.createElement(FormattedMessage, messages.certsFilesTitle)), /*#__PURE__*/_jsx("div", {}, void 0, files.map(function (item) {
    return /*#__PURE__*/_jsx(Attachment, {
      item: item,
      total: files.length,
      readOnly: true,
      displayConcisely: true
    }, item.path);
  })))), /*#__PURE__*/_jsx(ModalCloseBtn, {
    "data-test-id": "jMzJ_KYHUAYYBuv5HpzJw",
    fitMobileLandscapeFullWidth: true,
    onClick: onClose
  }));
};
export default compose(injectIntl, withStyles(s))(BundleCertDetails);